export enum Language {
  FR = 'fr',
  EN = 'en',
}

export interface Preferences {
  skipOnboarding?: boolean;
  favoriteProject?: string;
}
